import React from 'react';
import styled from 'styled-components';
import { colors } from './v4/styledComponents';
import instaIcon from '../../assets/footer/instagram.icon.png';
import contactInfos from '../../config/contactInfos';

const FooterMenuMobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Text = styled.p`
  font-family: Roboto;
  line-height: 30px;
  font-size: 12px;
  color: ${colors.black};
  margin: 0px;
  text-transform: uppercase;
  text-align: start;
`;

const InstaLink = styled.a`
  text-decoration: none;
  display: flex;
`;

const ContactLink = styled.a`
  text-decoration: none;
`;

const InstaIcon = styled.img`
  height: 12px;
  padding-left: 10px;
`;

const FooterMenuMobileAndSocial = () => (
  <FooterMenuMobileContainer>
    <ContactLink
      href={`mailto:${contactInfos.mail}`}
    >
      <Text>{contactInfos.mail}</Text>
    </ContactLink>
    <ContactLink
      href={`tel:${contactInfos.phoneNumberInter}`}
    >
      <Text>{contactInfos.phoneNumber}</Text>
    </ContactLink>
    <InstaLink
      target="_blank"
      rel="noreferrer noopener"
      href="https://www.instagram.com/tilli.jointhecycle/"
    >
      <Text>Instagram</Text>
      <InstaIcon src={instaIcon} alt="Icon Instagram" />
    </InstaLink>
  </FooterMenuMobileContainer>
);

export default FooterMenuMobileAndSocial;
